<script setup>
	import { ref, onMounted, onBeforeUnmount, watch } from "vue";
	import { useRouter } from 'vue-router'

    //reactive field proxies
	const activeId = ref(0);
	const topicRefs = ref({}); 
	const topics = ref({})

	//local variables
	const router = useRouter()
	let observer;

    //properties set by parent
    const props = defineProps({
    topic: {
        type: Object,
        required: true,
    }
    })

    //reactive field proxies
    const topic = ref(props.topic)

	//Methods	
	async function runSetup() {
        topics.value = [
            {
                "title" : "Contact Us",
                "anchor" : "Contact Us",
                "id" : 0
            },
            {
                "title" : "Permissions",
                "anchor" : "Permissions",
                "id" : 1
            },
            {
                "title" : "Get Email Updates from NCSES",
                "anchor" : "Get Email Updates from NCSES",
                "id" : 2
            }
        ]
	}

	runSetup() 

	onMounted(() => {
		observer = new IntersectionObserver(
			(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					activeId.value = entry.target.id;
				}
			});
			},
			{ threshold: 0.3 }
		);

		watch(topicRefs.value, () => {
			if('0' in topicRefs.value) {
				topics.value.forEach((section, index) => {
					if (topicRefs.value[index]) {
						observer.observe(topicRefs.value[index]);
					}
				});
			}
		})

        // Digital Analytics Program (https://digital.gov/guides/dap) 
        if(import.meta.env.VITE_APP_ENV && import.meta.env.VITE_APP_ENV === 'production') {
            const dapScript = document.createElement("script");
                dapScript.setAttribute("async", "")
                dapScript.setAttribute("id","_fed_an_ua_tag");
                dapScript.setAttribute("type","text/javascript");
                dapScript.setAttribute("src","https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=NSF");
            document.head.appendChild(dapScript);
        }
        
	});

	onBeforeUnmount(() => {
		if (observer) observer.disconnect();
	});

    function showHomePageError(msg) {
		const msgObj = {
			"text": msg.message?msg.message:msg,
			"type": "error"
		}
		router.push({
			name: 'HomeView',
			state: { "msgObj": msgObj } // stored in history.state, not URL
		}) 
	}
	
</script>
<template>
	<div class="container">
		<div class="intro-container">
			<div class="title">
				Media Archive
			</div>
			<div>
				<div class="separator-line"></div>
			</div>
			<div class="sub-title">
				Browse our media archive for video tutorials and articles to help you navigate and make the most of the Science & Engineering Indicators Explorer.
			</div>
		</div>
				
		<div class="section-container">
			<h2 class="title">Video Tutorials</h2>
            <div class="separator-line"></div>
            <p class="description">The following updates and corrections have been made to the Science and Engineering Indicators Explorer. To report an error, please send an email to 
				<span class="email_address">ncsesweb@nsf.gov</span>
			</p>

            <div class="chart-options-col222">
            </div>

		</div>



	</div>
</template>

<style scoped>

.container {
	background-color: var(--surface-color-Default);	
}

.intro-container {
	padding: var(--spacing-4xl, 3rem);
}

.intro-container .title {
	
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H1);
	font-style: normal;
	font-weight: 400;	
	color: var(--text-Header, #171717);
	text-align: center;
	line-height: var(--font-line-height-H1);
}

.intro-container .sub-title {
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base);
	font-style: normal;
	font-weight: 500;	
	color: var(--text-MedGrey, #2c2c2c);
	text-align: center;
}

.intro-container .img-container {
	text-align: center;
	margin-top: var(--spacing-4xl);
	border-radius: var(--radius-xl);
}

.toc-header {
	display: none;
	background: var(--surface-color-Tertiary);
	padding: var(--spacing-7xl) var(--spacing-4xl);
}
.section-container {
	display: flex;
	min-height: 100vh;
	margin-top: var(--spacing-4xl);
}

.alt-color {
	background-color: var(--surface-color-Tertiary);
}

.separator-line {
	width: 5rem;;
	height: 0.375rem;
	background-color: #005495;
	margin: 1.625rem auto;
}

.main-content {
	flex: 1;
    align-items: flex-start;
    align-self: stretch;
}
.sub-title {
    max-width: 629px;
    margin-left: auto;
    margin-right: auto;
}

/* 1023px - iPad */
@media (max-width: 63.9375rem) {
	.toc-header {
		display: block;
		padding: var(--spacing-xl);
	}

	.toc-header h2 {
		color: var(--text-Primary, #2C2C2C);
		font-size: var(--font-size-Caption, 14px);
		font-weight: 400;
		line-height: var(--font-line-height-Caption, 20px); /* 142.857% */
	}	

	.sidebar {
		display:none;
	}
}
</style>